/* @ngInject */
const mySterilesEditForm = (
  toaster,
  utils,
  $$sterile,
  labels
) => {
  return {
    restrict: 'E',
    scope: {
      mySteriles: '=',
      myWagonId: '=',
    },
    template: require('./mySterilesEditForm.html'),
    /* @ngInject */
    controller: ($scope) => {
      $scope.saveSteriles = async (_steriles) => {
        try {
          const response = await $$sterile.request.saveAll(_steriles, $scope.myWagonId)
          toaster.message(labels.sterile.log.saveAll.success(response.length))
          utils.$back()
        } catch (error) {
          toaster.error(error)
        }
      }
    },
    link: {
      pre: (scope, element, attrs) => {  },
      post: (scope, element, attrs, ctrl) => { },
    },
  }
}
export default mySterilesEditForm



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/sterile/directives/forms/mySterilesEditForm.js